module.exports = __webpack_public_path__ + "static/media/dashboard.3b232eb9.png";